import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { toast } from "react-toastify";
import './Contactus.css';

const Contactus = ({theme}) => {
    const [data, setData] = useState({
        name: "",
        email: "",
        subject: "",
        message: "",
    });
    const colorString = Object.values({theme}).toString();
    useEffect(() => {
        window.scrollTo(0, 0);

    }, [])

    const onDataChange = (e) => {
        setData({...data, [e.target.id]: e.target.value})
    };

    const onSend = (e) => {
        e.preventDefault();
        axios.post('https://appi.colexion.io/contactus', {...data}).then((res) => {
            console.log(res);
            toast.success("Success");
            setData({
                name: "",
                email: "",
                subject: "",
                message: "",
            })
        });
    }

    return(
        <div className={colorString === 'true'?`contact-us-container dark`: `contact-us-container whiteTheme`}>
            <div className="container">
                <div className="contact-us">
                    contact us
                </div>
                <div className="underline"></div>
                <div className="contact-us-content">
                    Have an issue, comment or technical concern? Please feel free to contact us anytime between 9.00 am to 6.00 PM Eastern Standard Time, Monday - Friday
                </div>
                <div className="divider"></div>
                <form className="contact-form" onSubmit={onSend}>
                    <div className="row">
                        <div className="col-md-6">
                            <label for="name" className="input-label">Name(Required)</label>
                            <input id="name" placeholder="Name" type="text" value={data.name} onChange={onDataChange} required></input>
                        </div>
                        <div className="col-md-6">
                        <label for="email" className="input-label">Email(Required)</label>
                            <input id="email" placeholder="Email" type="email"  value={data.email} onChange={onDataChange} required></input>
                        </div>
                    </div>
                    <div className="row long-input">
                        <label for="subject" className="input-label">Subject(Required)</label>
                        <input id="subject" placeholder="Subject" type="text"  value={data.subject} onChange={onDataChange} required></input>
                    </div>
                    <div className="row long-input">
                        <label for="message" className="input-label">Message(Required)</label>
                        <textarea id="message" placeholder="Message" rows="6"  value={data.message} onChange={onDataChange} required></textarea>
                    </div>
                    <button className="submit-button" type="submit">SEND</button>
                </form>
                <div className="get-in-touch-container">
                    <div className="get-in-touch">GET IN TOUCH</div>
                    <div className="underline"></div>
                    <div className="row email-container">
                        <img src={process.env.PUBLIC_URL + '/images/mail-icon.png'} alt="" className="Icon-material-mail"></img>
                        <div className="colexion-email">info@colexion.io</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Contactus;